import { Component, Inject, ElementRef } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { DOCUMENT } from "@angular/platform-browser";
import { BsDropdownModule } from 'ngx-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormGroup, FormArray, FormBuilder } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {

  isCollapsed = true;
  checkSearch = false;
  baseSystem = environment.baseSystem;
  txtsearch: string="";
  group: Number;
  supplierAccess: boolean;
  //public searchForm: FormGroup;

  constructor(@Inject(DOCUMENT) private document, public _authService: AuthService, private _el: ElementRef, private _router: Router, private _fb: FormBuilder, private activatedRoute: ActivatedRoute) {
    if (this._authService.getUserData() != undefined && this._authService.getUserData() != null) {
      this.group = this._authService.getUserData().groupIds[0];
      this.supplierAccess = this._authService.getUserData().supplierAccess;
    }

    if (this.group === 4) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_amcal.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_amcal.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_amcal.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_amcal.css');
    }
    if (this.group === 6) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_guardian.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_guardian.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_guardian.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_guardian.css');
    }

  }


  ngOnInit() {
    $(".dropdown-menu").hide();
    $("#dropdownFix1").hide();
  }

  onHidden(): void {
    console.log('Dropdown is hidden');
    if (this.checkSearch == false) {
      // this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('show');
      //  this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('dropdown-menuFix');
      $(".dropdown-menu").hide(500);
      this.checkSearch = false;
    }
  }
  onShown(): void {
    console.log('Dropdown is shown');
    if (this.checkSearch == true) {
      // this._el.nativeElement.querySelector('.dropdown-menu').classList.add('show');
      // this._el.nativeElement.querySelector('.dropdown-menu').classList.remove('dropdown-menuFix');
      $(".dropdown-menu").show(500);
      this.checkSearch = true;
    }

  }
  isOpenChange(): void {
    console.log('Dropdown state is changed');
  }

  onClickSearch() {
    console.log('Search clicked');
    if (this.checkSearch == false) {
      this.checkSearch = true;
      this.onShown();
    } else {
      this.checkSearch = false;
      this.onHidden();
    }

  }




  submitSearch(){

    console.log('submit Search');
    // console.log(this.searchForm.controls.txtsearch.value);

      this._router.navigate(['/search', { txtsearch: this.txtsearch } ], { relativeTo: this.activatedRoute, queryParams: { } } );

    }

  guardian() {

    this._authService.setUserDataView(6);
    this.group = this._authService.getUserData().groupIds[0];

    if (this.group === 4) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_amcal.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_amcal.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_amcal.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_amcal.css');
    }
    if (this.group === 6) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_guardian.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_guardian.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_guardian.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_guardian.css');
    }

  }

  amcal() {

    this._authService.setUserDataView(4);
    this.group = this._authService.getUserData().groupIds[0];

    if (this.group === 4) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_amcal.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_amcal.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_amcal.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_amcal.css');
    }

  }

  sigma() {

    this._authService.setUserDataView(0);
    this.group = this._authService.getUserData().groupIds[0];

    if (this.group === 0) {
      this.document.getElementById('appcss').setAttribute('href', '/scss/app_sigma.css');
      this.document.getElementById('customcss').setAttribute('href', '/scss/custom_sigma.css');
      this.document.getElementById('profilecss').setAttribute('href', '/scss/profile_sigma.css');
      this.document.getElementById('headercss').setAttribute('href', '/scss/headers/header-v1_sigma.css');

    }


  }



}



// WEBPACK FOOTER //
// ./src/app/shared/navigation/navbar.component.ts